module.exports = __webpack_public_path__ + "static/img/buble_approves.5cd3c4e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buble_approves.gif
// module id = L0N3
// module chunks = 0